<template lang="html">
  <div class="roundtable-settings-container relative mv3 center">
    <walkthrough
      componentName="onlineConfiguration"
      style="position: absolute; top: 16px; right: 10px"
    />
    <!-- Top Header With selection Buttons -->
    <div class="flex flex-nowrap between-xs pv2">
      <pl-button
        class="pl-no-margin"
        :class="{ selected: selected_tab === 'anonymitySettingsTab' }"
        style="margin-left: -12px"
        @click.native="selectTab('anonymitySettingsTab')"
      >
        Anonymity: {{ getCurrentRT.enable_annonymous ? 'on' : 'off' }}
        <i
          v-if="selected_tab === 'anonymitySettingsTab'"
          class="fa fa-chevron-up"
        ></i>
        <i v-else class="fa fa-chevron-down"></i>
      </pl-button>
      <pl-button
        class="pl-no-margin"
        :class="{ selected: selected_tab === 'assessmentSettingsTab' }"
        @click.native="selectTab('assessmentSettingsTab')"
      >
        Assessment: {{ getCurrentRT.enable_grading ? 'on' : 'off' }}
        <i
          v-if="selected_tab === 'assessmentSettingsTab'"
          class="fa fa-chevron-up"
        ></i>
        <i v-else class="fa fa-chevron-down"></i>
      </pl-button>
      <pl-button
        class="pl-no-margin"
        :class="{ selected: selected_tab === 'guidanceQuestionsSettingsTab' }"
        @click.native="selectTab('guidanceQuestionsSettingsTab')"
      >
        Peer Feedback
        <i
          v-if="selected_tab === 'guidanceQuestionsSettingsTab'"
          class="fa fa-chevron-up"
        ></i>
        <i v-else class="fa fa-chevron-down"></i>
      </pl-button>
    </div>
    <div id="onboarding-roundtable-settings-bar" />
    <!-- Dyanamically render the Assessment / Anonymity / guidanceQuestionsSettings tabs -->
    <transition name="slide-fade-up" mode="out-in">
      <component
        @closeTab="selected_tab = null"
        class="start-xs"
        :is="selected_tab"
      />
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  // Import Tab Components
  import AnonymitySettingsTab from './roundtableSettingsTabs/anonymitySettingsTab';
  import AssessmentSettingsTab from 'components/assessmentSettingsTab';
  import GuidanceQuestionsSettingsTab from './roundtableSettingsTabs/guidanceQuestionsSettingsTab';
  import Walkthrough from 'features/onlineWalkthrough/onlineWalkthroughDot';

  export default {
    data() {
      return {
        selected_tab: null,
      };
    },
    components: {
      AnonymitySettingsTab,
      AssessmentSettingsTab,
      GuidanceQuestionsSettingsTab,
      Walkthrough,
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    methods: {
      // If you're selecting the same tab that you're on already, close it
      selectTab(selection) {
        this.selected_tab = this.selected_tab === selection ? null : selection;
      },
      redirectToSettings() {
        this.$router.push({
          name: 'roundtable.edit',
        });
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'
  .selected
    border: 1px solid alpha(pl-ruby, 0.2) !important
    background: alpha(pl-ruby, 0.05) !important
  .fa
    font-size: 10px
  .roundtable-settings-container
    padding: 0px 40px
    max-width: 680px
    background: #fff
    border: 1px solid pl-fog
    border-radius: 5px
  .selection-container
    margin-top: 15px
  .radio-button-container
    margin-left: 20px
    margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// roundtableSettingsInFeed.vue?473b1186